const appRoutes = []

export default appRoutes
